export default __webpack_public_path__ + "1ad4a10c8c7f910379b70072feaacebe.png";